import React, { useEffect, useState } from 'react';
import { MdArrowBackIos, MdArrowForwardIos } from 'react-icons/md';
import { useSearchParams } from 'react-router-dom';

import { Button } from '@aws-amplify/ui-react';
import { Box, Grid } from '@mui/material';
import dayjs from 'dayjs';
import { useSetRecoilState } from 'recoil';

import { getSectionUsageStatusApi } from '@apis/index';
import { MessageDialogState } from '@atom/DialogState';
import { LoadingState } from '@atom/LoadingState';

import { GetSectionUsageStatusQueryVariables } from '../../../API';
import SectionScheduleTimeArea from './SectionScheduleTimeArea';
import SectionScheduleTimeLine from './SectionScheduleTimeLine';

const viewStyles = {
  width: '100%',
  display: 'flex',
  margin: 0,
  padding: 0
};

const Scheduler = () => {
  /* 共通State */
  const setMessageDialogState = useSetRecoilState(MessageDialogState);
  const setLoading = useSetRecoilState(LoadingState);

  const [searchParams, setSearchParams] = useSearchParams();

  const areaId = searchParams.get('areaId') ?? '';
  const facilityId = searchParams.get('facilityId') ?? '';
  const date = searchParams.get('date') ?? '';
  const title = searchParams.get('title') ?? '';

  const [sectionUsages, setSecionUsages] = useState<any>(null);
  const [selectDay, setSelectDay] = useState(dayjs(date));
  const dispDay = selectDay.format('YYYY年M月D日(dd)');

  const nextDay = () => {
    setSelectDay(selectDay.add(1, 'day'))
    // クエリパラメータの更新
    setSearchParams({
      areaId,
      facilityId,
      date: selectDay.add(1, 'day').format('YYYY-MM-DD'),
      title
    });
  };
  const prevDay = () => {
    setSelectDay(selectDay.subtract(1, 'day'));
    // クエリパラメータの更新
    setSearchParams({
      areaId,
      facilityId,
      date: selectDay.subtract(1, 'day').format('YYYY-MM-DD'),
      title
    });
  }

  // 検索処理
  const getData = async () => {
    setLoading(true);
    try {
      const input: GetSectionUsageStatusQueryVariables = {
        input: {
          areaId,
          facilityId,
          targetDate: selectDay.format('YYYY-MM-DD')
        }
      };

      const result = await getSectionUsageStatusApi(input);
      setSecionUsages(result);
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
      // eslint-disable-next-line no-console
      console.error(error);

      let message = '時間をおいてから再度お試しください。解決できない場合は管理者へお問い合わせください。';
      if ('errors' in error && error.errors.length !== 0) {
        message = error.errors[0].message;
      }
      setMessageDialogState({
        open: true,
        messageData: {
          title: 'エラーが発生しました。',
          message
        }
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, [selectDay]);

  return (
    <Box display="Flex" sx={{ flexDirection: 'column' }}>
      <Box sx={{ position: 'fixed', width: '100%', backgroundColor: '#FFFFFF', zIndex: 998 }}>
        <Grid container spacing={2} direction="row" justifyContent="space-between" alignItems="center">
          <Grid item xs={3}>
            <Box sx={{ textAlign: 'left', marginLeft: '10px' }}>
              <Button
                style={{
                  backgroundColor: 'white',
                  color: '#667080',
                  borderColor: '#667080',
                  borderRadius: '15px',
                  fontWeight: '400',
                  fontSize: '10px'
                }}
                onClick={prevDay}
              >
                <MdArrowBackIos />
                先日
              </Button>
            </Box>
          </Grid>
          <Grid item xs="auto">
            <p>{dispDay}</p>
          </Grid>
          <Grid item xs={3}>
            <Box sx={{ textAlign: 'right', marginRight: '10px' }}>
              <Button
                style={{
                  backgroundColor: 'white',
                  color: '#667080',
                  borderColor: '#667080',
                  borderRadius: '15px',
                  fontWeight: '400',
                  fontSize: '10px'
                }}
                onClick={nextDay}
              >
                翌日
                <MdArrowForwardIos />
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Box>
      <Box sx={{ marginTop: '55px' }}>
        {sectionUsages && (
          <Box sx={viewStyles}>
            <SectionScheduleTimeLine
              startTime={sectionUsages.availableStartTime}
              endTime={sectionUsages.availableEndTime}
            />
            <SectionScheduleTimeArea sectionUsages={sectionUsages} />
          </Box>
        )}
      </Box>
    </Box>
  );
};
export default Scheduler;
